var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 168.083,
    height: 41.678,
    viewBox: "0 0 168.083 41.678",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "app_store",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9810",
    "data-name": "Path 9810",
    d: "M161.757,41.678H6.325C2.834,41.678,0,39.29,0,36.349V5.329C0,2.388,2.833,0,6.325,0H161.757c3.492,0,6.321,2.388,6.326,5.329V36.349c0,2.942-2.834,5.325-6.326,5.329M6.325,1.051c-2.8,0-5.075,1.917-5.077,4.278v31.02c0,2.362,2.274,4.275,5.077,4.278H161.757c2.8,0,5.076-1.916,5.078-4.278V5.329c0-2.362-2.274-4.275-5.077-4.278Z",
    transform: "translate(0 0)",
    fill: "#96b3ea",
    opacity: 0.411
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9811",
    "data-name": "Path 9811",
    d: "M71.1,14.685l-.481,1.587H69.561l1.795-5.591h1.305l1.816,5.591h-1.1l-.506-1.584Zm1.6-.772-.441-1.377c-.106-.34-.2-.722-.281-1.045h-.016c-.082.326-.163.713-.266,1.045l-.432,1.377Z",
    transform: "translate(-6.33 -1.719)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9812",
    "data-name": "Path 9812",
    d: "M80.7,13.594l.653,2.049c.117.356.2.68.274,1.01h.025c.075-.332.163-.647.274-1.01l.653-2.049h1.07l-1.541,4.039H81.1l-1.5-4.039Z",
    transform: "translate(-11.033 -3.085)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9813",
    "data-name": "Path 9813",
    d: "M91.862,16.583a5.43,5.43,0,0,0,.066.972h-.921l-.074-.448h-.025a1.478,1.478,0,0,1-1.194.536,1.2,1.2,0,0,1-1.269-1.207c0-1.01.9-1.534,2.4-1.526v-.066c0-.266-.106-.706-.821-.706a2.139,2.139,0,0,0-1.087.3l-.2-.664a2.912,2.912,0,0,1,1.46-.356,1.513,1.513,0,0,1,1.667,1.708Zm-1-1c-.722-.008-1.41.141-1.41.755a.535.535,0,0,0,.581.58.838.838,0,0,0,.8-.556.684.684,0,0,0,.025-.224Z",
    transform: "translate(-15.178 -3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9814",
    "data-name": "Path 9814",
    d: "M98.035,11.482a.578.578,0,1,1,.008,0Zm-.506.58h1.024V16.1H97.53Z",
    transform: "translate(-19.403 -1.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3473",
    "data-name": "Rectangle 3473",
    width: 1.021,
    height: 5.899,
    transform: "translate(80.614 8.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9815",
    "data-name": "Path 9815",
    d: "M109.855,16.584a5.483,5.483,0,0,0,.066.971H109l-.075-.448H108.9a1.477,1.477,0,0,1-1.2.539,1.2,1.2,0,0,1-1.269-1.2c0-1.01.9-1.534,2.4-1.526v-.066c0-.266-.106-.706-.821-.706a2.139,2.139,0,0,0-1.087.3l-.2-.664a2.911,2.911,0,0,1,1.46-.356,1.513,1.513,0,0,1,1.667,1.708Zm-.994-1c-.721-.008-1.41.141-1.41.755a.535.535,0,0,0,.58.58.836.836,0,0,0,.8-.556.683.683,0,0,0,.025-.224Z",
    transform: "translate(-23.609 -3.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9816",
    "data-name": "Path 9816",
    d: "M115.556,10.1h1.021v2.415h.016a1.463,1.463,0,0,1,1.295-.648c.986,0,1.692.821,1.684,2.049a1.935,1.935,0,0,1-1.834,2.174,1.387,1.387,0,0,1-1.276-.7h-.016L116.4,16h-.87c.016-.274.033-.722.033-1.128Zm1.021,4.231a1.175,1.175,0,0,0,.024.245.933.933,0,0,0,.9.713c.638,0,1.029-.506,1.029-1.329,0-.714-.34-1.294-1.021-1.294a.95.95,0,0,0-.9.744,1.259,1.259,0,0,0-.033.266Z",
    transform: "translate(-27.867 -1.447)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3474",
    "data-name": "Rectangle 3474",
    width: 1.021,
    height: 5.899,
    transform: "translate(92.905 8.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9817",
    "data-name": "Path 9817",
    d: "M130.586,15.822a1.1,1.1,0,0,0,1.244,1.045,3.263,3.263,0,0,0,1.12-.182l.15.7a3.634,3.634,0,0,1-1.411.258,1.913,1.913,0,0,1-2.082-2.039,2,2,0,0,1,1.975-2.172,1.756,1.756,0,0,1,1.742,1.966,2.538,2.538,0,0,1-.033.432Zm1.775-.715a.869.869,0,0,0-.838-.987,1,1,0,0,0-.937.987Z",
    transform: "translate(-34.463 -3.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9818",
    "data-name": "Path 9818",
    d: "M144.287,17.646a1.954,1.954,0,0,1-2.025-2.082,2,2,0,0,1,2.091-2.141,1.939,1.939,0,0,1,2.008,2.073,2,2,0,0,1-2.066,2.149Zm.033-.739c.58,0,.987-.564.987-1.387,0-.631-.282-1.361-.979-1.361-.722,0-1.013.706-1.013,1.378,0,.78.391,1.369,1,1.369Z",
    transform: "translate(-40.392 -3.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9819",
    "data-name": "Path 9819",
    d: "M152.21,14.717c0-.464-.016-.855-.033-1.2h.888l.05.606h.025a1.485,1.485,0,0,1,1.295-.7c.7,0,1.435.456,1.435,1.733v2.4h-1.022V15.271c0-.581-.216-1.021-.772-1.021a.856.856,0,0,0-.8.6.938.938,0,0,0-.05.326V17.56h-1.021Z",
    transform: "translate(-45.04 -3.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9820",
    "data-name": "Path 9820",
    d: "M166.578,11.643V12.68h.972v.764h-.972v1.776c0,.5.133.744.522.744a1.335,1.335,0,0,0,.4-.042l.017.771a2.232,2.232,0,0,1-.739.106,1.169,1.169,0,0,1-.879-.332,1.592,1.592,0,0,1-.326-1.137V13.443H165V12.68h.571v-.755Z",
    transform: "translate(-51.049 -2.171)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9821",
    "data-name": "Path 9821",
    d: "M171.934,10.1h1.021v2.406h.016a1.347,1.347,0,0,1,.506-.457,1.443,1.443,0,0,1,.706-.182c.688,0,1.41.457,1.41,1.751V16h-1.02V13.724c0-.581-.216-1.029-.78-1.029a.85.85,0,0,0-.8.571.925.925,0,0,0-.042.308V16h-1.021Z",
    transform: "translate(-54.297 -1.447)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9822",
    "data-name": "Path 9822",
    d: "M182.031,15.822a1.1,1.1,0,0,0,1.244,1.045,3.263,3.263,0,0,0,1.12-.182l.15.7a3.631,3.631,0,0,1-1.41.258,1.913,1.913,0,0,1-2.083-2.039,2,2,0,0,1,1.975-2.172,1.756,1.756,0,0,1,1.742,1.966,2.6,2.6,0,0,1-.033.432Zm1.775-.715a.868.868,0,0,0-.838-.987,1,1,0,0,0-.937.987Z",
    transform: "translate(-58.568 -3.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9823",
    "data-name": "Path 9823",
    d: "M35.445,25.787a4.976,4.976,0,0,1,2.371-4.176A5.1,5.1,0,0,0,33.8,19.44c-1.689-.177-3.327,1.01-4.186,1.01-.878,0-2.2-.994-3.631-.966a5.35,5.35,0,0,0-4.5,2.748c-1.944,3.372-.494,8.318,1.37,11.04.931,1.335,2.02,2.823,3.446,2.774,1.395-.058,1.913-.888,3.6-.888,1.669,0,2.158.888,3.614.855,1.5-.024,2.439-1.339,3.339-2.685a10.971,10.971,0,0,0,1.528-3.11,4.813,4.813,0,0,1-2.937-4.427",
    transform: "translate(16.628 -5.815)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9824",
    "data-name": "Path 9824",
    d: "M40.513,12.993a4.89,4.89,0,0,0,1.119-3.508,4.985,4.985,0,0,0-3.225,1.67,4.66,4.66,0,0,0-1.152,3.381A4.122,4.122,0,0,0,40.512,13",
    transform: "translate(8.81 -1.159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9825",
    "data-name": "Path 9825",
    d: "M78.029,40.24h-1.94L75.028,36.9H71.323L70.308,40.24H68.415l3.671-11.393H74.35ZM74.7,35.488l-.963-2.976q-.155-.454-.571-2.145h-.032q-.17.728-.542,2.145l-.946,2.976Z",
    transform: "translate(-5.793 -10.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9826",
    "data-name": "Path 9826",
    d: "M97.285,38.684A4.669,4.669,0,0,1,96.152,42a3.31,3.31,0,0,1-2.514,1.081A2.523,2.523,0,0,1,91.3,41.912h-.033v4.324H89.445V37.382c0-.879-.022-1.778-.068-2.7h1.605l.1,1.305h.034a3.245,3.245,0,0,1,5.2-.319,4.53,4.53,0,0,1,.972,3.025m-1.86.067a3.389,3.389,0,0,0-.541-1.978,1.933,1.933,0,0,0-2.812-.364,2.079,2.079,0,0,0-.716,1.175,2.384,2.384,0,0,0-.082.556v1.371a2.194,2.194,0,0,0,.547,1.512,1.822,1.822,0,0,0,1.429.617,1.86,1.86,0,0,0,1.6-.794,3.488,3.488,0,0,0,.576-2.1",
    transform: "translate(-15.614 -12.885)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9827",
    "data-name": "Path 9827",
    d: "M115.062,38.684A4.667,4.667,0,0,1,113.927,42a3.308,3.308,0,0,1-2.518,1.081,2.52,2.52,0,0,1-2.331-1.166h-.034v4.324h-1.825V37.382c0-.879-.024-1.778-.068-2.7h1.6l.1,1.305h.035a3.244,3.244,0,0,1,5.2-.319,4.529,4.529,0,0,1,.971,3.025m-1.86.067a3.382,3.382,0,0,0-.542-1.978,1.871,1.871,0,0,0-1.588-.812,1.9,1.9,0,0,0-1.224.448,2.079,2.079,0,0,0-.717,1.176,2.292,2.292,0,0,0-.082.556v1.371a2.187,2.187,0,0,0,.548,1.512,1.818,1.818,0,0,0,1.429.617,1.866,1.866,0,0,0,1.6-.794,3.508,3.508,0,0,0,.576-2.1",
    transform: "translate(-23.943 -12.885)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9828",
    "data-name": "Path 9828",
    d: "M135.685,36.89a3.035,3.035,0,0,1-1.013,2.366,4.487,4.487,0,0,1-3.1,1,5.444,5.444,0,0,1-2.954-.71l.425-1.521a5.01,5.01,0,0,0,2.64.726,2.5,2.5,0,0,0,1.6-.463,1.521,1.521,0,0,0,.571-1.245,1.594,1.594,0,0,0-.472-1.169,4.4,4.4,0,0,0-1.574-.881q-2.991-1.116-2.99-3.268a2.887,2.887,0,0,1,1.047-2.3,4.136,4.136,0,0,1,2.789-.9,5.527,5.527,0,0,1,2.585.542l-.455,1.488a4.5,4.5,0,0,0-2.179-.524,2.2,2.2,0,0,0-1.5.473,1.357,1.357,0,0,0-.456,1.031,1.387,1.387,0,0,0,.523,1.116,5.874,5.874,0,0,0,1.657.88,5.633,5.633,0,0,1,2.163,1.387,2.907,2.907,0,0,1,.691,1.978",
    transform: "translate(-34.001 -10.078)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9829",
    "data-name": "Path 9829",
    d: "M148.86,34.391h-2.012v3.989q0,1.522,1.066,1.521a3.315,3.315,0,0,0,.81-.082l.05,1.387a4.1,4.1,0,0,1-1.419.2,2.187,2.187,0,0,1-1.69-.658,3.238,3.238,0,0,1-.609-2.215V34.391h-1.2V33.023h1.2v-1.5l1.795-.542v2.045h2.012Z",
    transform: "translate(-41.141 -11.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9830",
    "data-name": "Path 9830",
    d: "M163.255,38.713a4.506,4.506,0,0,1-1.082,3.11,3.862,3.862,0,0,1-3.009,1.25,3.671,3.671,0,0,1-2.882-1.2,4.363,4.363,0,0,1-1.074-3.024,4.457,4.457,0,0,1,1.109-3.125,3.827,3.827,0,0,1,2.982-1.219,3.752,3.752,0,0,1,2.908,1.2,4.33,4.33,0,0,1,1.048,3.009m-1.894.059a3.7,3.7,0,0,0-.489-1.95,1.8,1.8,0,0,0-1.638-.983,1.829,1.829,0,0,0-1.673.983,3.774,3.774,0,0,0-.489,1.985,3.7,3.7,0,0,0,.489,1.948,1.841,1.841,0,0,0,1.658.983,1.821,1.821,0,0,0,1.637-1,3.7,3.7,0,0,0,.507-1.966",
    transform: "translate(-46.459 -12.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9831",
    "data-name": "Path 9831",
    d: "M177.642,36.282a3.236,3.236,0,0,0-.571-.05,1.731,1.731,0,0,0-1.488.728,2.741,2.741,0,0,0-.455,1.622v4.31H173.3l.015-5.629q0-1.42-.067-2.587h1.589l.067,1.573h.049a2.813,2.813,0,0,1,.914-1.305,2.209,2.209,0,0,1,1.32-.44,3.006,3.006,0,0,1,.455.033Z",
    transform: "translate(-54.914 -12.883)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9832",
    "data-name": "Path 9832",
    d: "M190.434,38.374a4.4,4.4,0,0,1-.069.829h-5.474a2.387,2.387,0,0,0,.794,1.86,2.71,2.71,0,0,0,1.795.571,6.068,6.068,0,0,0,2.213-.388l.286,1.268a6.866,6.866,0,0,1-2.756.508,3.986,3.986,0,0,1-3-1.126,4.16,4.16,0,0,1-1.09-3.018,4.71,4.71,0,0,1,1.015-3.093,3.5,3.5,0,0,1,2.87-1.317,3.065,3.065,0,0,1,2.692,1.317,4.446,4.446,0,0,1,.724,2.587m-1.741-.473a2.473,2.473,0,0,0-.353-1.4,1.6,1.6,0,0,0-1.453-.76,1.735,1.735,0,0,0-1.453.744A2.7,2.7,0,0,0,184.9,37.9Z",
    transform: "translate(-59.543 -12.864)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app_store.2d4586c3ecf0811d0c241a17ba282368.svg";
export { ForwardRef as ReactComponent };